import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useGlobalStyles = makeStyles((theme: Theme) => ({
    // Define global style classes here
    hidden: {
        display: 'none',
    },
    flex: {
        flex: 1,
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexCol: {
        display: 'flex',
        flexDirection: 'column',
    },
    gap8: {
        gap: theme.spacing(1),
    },
    relative: {
        position: 'relative',
    },
    underline: {
        textDecoration: 'underline',
        '&:hover': {
            textDecoration: 'unset',
        },
    },
    visuallyHidden: {
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        border: 0,
    },
    action: {
        cursor: 'pointer',
    },
    textEllipsis: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    textOverflowWrap: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        overflowWrap: 'anywhere',
    },

    // MODAL
    modalRating: {
        '& > h2': {
            paddingBottom: 4,
        },
        '& > div > div:last-child': {
            position: 'sticky',
            bottom: -30,
            background: theme.palette.colors.background.appBar,
            zIndex: 1,
            paddingTop: 4,
        },
    },
    modalBottomRating: {
        width: '100%!important',
        // height: '85%!important',
        borderBottomLeftRadius: '0!important',
        borderBottomRightRadius: '0!important',
        margin: 0,
    },

    // ADMIN
    adminContainer: {
        marginRight: 110,
    },

    // Encoche scrollable (ios Like)
    pageOpenCloseContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
    },
    pageOpenClose: {
        height: 4,
        width: 40,
        backgroundColor: theme.palette.colors.background.menuSeparator,
        borderRadius: 8,
        alignSelf: 'center',
    },

    // EVENTS
    wickedGradient: {
        background: 'linear-gradient(88.84deg, #DC5A91 1.01%, #419155 99.02%)!important',
    },
}));

export default useGlobalStyles;
